import React, { useEffect, createElement } from 'react';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Chapters } from './components/Chapters';
import { PreviewCarousel } from './components/PreviewCarousel';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    const pixelId = '1252242806993118';
    // Initialize fbq queue safely (mirrors Meta's snippet without unsafe DOM lookups)
    const w = window as any;
    if (!w.fbq) {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      w.fbq = n;
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      if (noscript.parentNode) {
        noscript.parentNode.removeChild(noscript);
      }
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-brand-text selection:bg-brand-green selection:text-white" data-id="element-0">
      <CountdownBar data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProof data-id="element-3" />
      <Chapters data-id="element-4" />
      <PreviewCarousel data-id="element-5" />
      <Testimonials data-id="element-6" />
      <Bonuses data-id="element-7" />
      <Pricing data-id="element-8" />
      <Guarantee data-id="element-9" />
      <Footer data-id="element-10" />
      <PurchasePopup data-id="element-11" />
    </div>;
}